import { CallAPIServerWithFile } from "@/util/GetAPIPermission";
import { APIUploadResult } from "./upload.type";
export type UploadRequestParams = {
    file: any;
    platform?: string;
    destination?: string;
    size?: number[];
};
export const CallAPI_Upload = async (request: UploadRequestParams) => {
    const formData = new FormData();
    formData.append("file", request.file);
    
    // เพิ่มข้อมูลอื่น ๆ ใน FormData
    if (request.platform) formData.append("platform", request.platform);
    if (request.destination) formData.append("destination", request.destination);
    if (request.size) formData.append("size", JSON.stringify(request.size));
    
    // ใช้ CallAPIServerWithFile สำหรับการอัปโหลด
    const result = await CallAPIServerWithFile<APIUploadResult>("/upload", "POST", formData, true);

    return result;
};